import { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {
	state = {
		error: null,
		errorInfo: null,
	};

	componentDidCatch(error, errorInfo) {
		this.setState({
			error,
			errorInfo,
		});
	}

	render() {
		const { children, ...reset } = this.props;
		const { error, errorInfo } = this.state;

		if (error) {
			// You can render any custom fallback UI
			// The text below is not localized because we want to import only React lib
			return (
				<div style={{ padding: '1em' }} {...reset}>
					<h3>Na stránce došlo k neočekávané chybě.</h3>
					<h4>{this.state.error && this.state.error.toString()}</h4>

					<p>Bližší detaily k chybě jsou k nalezení i v konzoli prohlížeče (po stisku klávesy F12).</p>

					<details style={{ whiteSpace: 'pre-wrap' }}>{errorInfo && errorInfo.componentStack}</details>
				</div>
			);
		}

		return children;
	}
}

ErrorBoundary.propTypes = {
	children: PropTypes.any,
};

export default ErrorBoundary;
